import { BsFillTrash3Fill } from "react-icons/bs";
import ServiceProviderModal from "./ServiceProviderModal";
import CopyToClipboard from './CopyToClipboard';
import DeleteModal from './DeleteModal';
import React, { useEffect, useState } from 'react';
import { getInfo, FetchIndividual, GetServiceProvider, DeleteServiceProvider } from "../utilities/calls";
import {  AiOutlineProfile } from "react-icons/ai";

export default function PrivateServiceProviders() {
    const [serviceProviderIds, setServiceProviderIds] = useState([]);
    const [serviceProviderModal, setServiceProviderModal] = useState(false);
    const [selectedSP, setSelectedSP] = useState(null);
    const [showAlert, setShowAlert] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [showDeleteDlg, setShowDeleteDlg] = useState(false);
    const [currSpId, setCurrSpId] = useState(null);
    let timer = undefined;

    useEffect(() => {
        loadServiceProviderIds();
    }, []);

    useEffect(() => {
        return () => clearInterval(timer);
    }, [timer])

    const loadServiceProviderIds = () => {
        const individualId = getInfo("IndividualID");
        if (!individualId) return;
        FetchIndividual(individualId)
            .then(individualData => {
                const ids = individualData?.privateserviceproviders?.map(sp => sp.id) || [];
                setServiceProviderIds(ids);
            })
            .catch(error => {
                console.error("Error fetching individual:", error);
                showTemporaryAlert('Error loading service providers, please try again.');
            });
    };

    const showTemporaryAlert = (text) => {
        setShowAlert(true);
        setAlertText(text);
        timer = setTimeout(() => {
            setShowAlert(false);
        }, 2000);
    };

    const addServiceProvider = () => {
        setSelectedSP({});
        setServiceProviderModal(true);
    };

    const confirmDeleteServiceProvider = (spid) => {
        setCurrSpId(spid);
        setShowDeleteDlg(true);
    };

    const deleteServiceProvider = () => {
        setShowDeleteDlg(false);
        DeleteServiceProvider(currSpId, true)
            .then(() => {
                showTemporaryAlert('Service Provider deleted successfully.');
                setServiceProviderIds([]);
                loadServiceProviderIds();
            })
            .catch(error => {
                console.error('Error deleting provider:', error);
                showTemporaryAlert('Error deleting provider.');
            });
    };

    return (
        <div className='space-y-3 px-1 md:px-4 py-3 max-w-screen-xl mx-auto items-center'>
            {showAlert && (
                <div className="bg-blue-100 border-blue-500 text-blue-700 px-2 py-2 relative" role="alert">
                    <button className="absolute top-2 right-1 text-lg font-normal text-gray-700" onClick={() => setShowAlert(false)}>X</button>
                    <span className="text-sm">{alertText}</span>
                </div>
            )}

            <DeleteModal 
                confirmationText="Are you sure you want to delete this Service Provider?" 
                deleteLabel="Delete" 
                onDeleteFn={deleteServiceProvider} 
                onCancelFn={() => setShowDeleteDlg(false)} 
                show={showDeleteDlg} 
            />

            <h1 className="bold-text-input">Private Service Providers</h1>

            {serviceProviderIds.length === 0 && (
                <p className="text-small py-3">
                    Save your physician, insurance, mechanic, emergency contact details to easily access them. Only visible to you.
                </p>
            )}

            <button className="button-style hover:bg-555 mb-2" onClick={addServiceProvider}>
                <AiOutlineProfile className="inline-icon" />
                Add Service Provider
            </button>

            <div className="p-5 border border-gray-700 mt-2">
                <ul className="w-full divide-y divide-gray-700">
                    {serviceProviderIds.map((id) => (
                        <ServiceProviderItem 
                            spid={id}
                            onDelete={confirmDeleteServiceProvider}
                        />
                    ))}
                </ul>
            </div>

            {serviceProviderModal && (
                <ServiceProviderModal
                    setServiceProviderModal={setServiceProviderModal}
                    serviceProviders={serviceProviderIds}
                    sp={selectedSP}
                    onUpdate={loadServiceProviderIds}
                />
            )}
        </div>
    );
}

function ServiceProviderItem({ spid, onDelete }) {
    const [spDetails, setSpDetails] = useState(null);
    const [serviceProviderModal, setServiceProviderModal] = useState(false);

    useEffect(() => {
        if (!spDetails) {
            GetServiceProvider(spid, true)
                .then(details => {
                    setSpDetails(details);
                })
                .catch(error => {
                    console.error('Error loading service provider details:', error);
                });
        }
    }, [ spid, spDetails]);

    const updateSP = () => {
        setServiceProviderModal(true);
    }

    const refreshSP = () => {
        setSpDetails(undefined)
    }

    return (
        <><li className="pb-3 sm:pb-4">
            {spDetails ? (
                <>
                    <div className="flex items-center space-x-4 rtl:space-x-reverse">
                        <div className="flex-1">
                            <p className="text-base font-semibold truncate text-blue-400">
                                <button onClick={() => updateSP(spDetails)}>
                                    {spDetails.tags?.name?.Value || "No Name"}
                                </button>
                            </p>
                        </div>
                        <div className="inline-flex items-center text-white">
                            <button onClick={() => onDelete(spid)} className="bg-slate-333 py-1 hover:bg-555">
                                <BsFillTrash3Fill title="Delete" className="inline-icon" />
                            </button>
                        </div>
                    </div>
                    <p className="text-sm text-gray-400">
                        <span id={"sp_guid_" + spid}>{spid}</span>
                        <CopyToClipboard elId={"sp_guid_" + spid} />
                    </p>
                </>
            ) : (
                <div className="animate-pulse text-gray-500">Loading...</div>
            )}
        </li>
        {serviceProviderModal && (
            <ServiceProviderModal
                setServiceProviderModal={setServiceProviderModal}
                serviceProviders={null}
                sp={spDetails}
                onUpdate={refreshSP}
            />
        )}</>
    );
}